import Header from "pages/MainPage/Header/Header";
import "./App.scss";
import MainScreen from "pages/MainPage/MainScreen/MainScreen";
import LocalizationSection from "pages/MainPage/LocalizationSection/LocalizationSection";
import GymEntranceInstruction from "pages/MainPage/GymEntranceInstruction/GymEntranceInstruction";
import Footer from "pages/MainPage/Footer/Footer";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainGallery from "pages/MainGalleryPage/MainGallery/MainGallery";
import MobileMenu from "pages/Components/MobileMenu/MobileMenu";
import ScrollTop from "hooks/ScrollTop";
import NotFoundPage from "pages/NotFoundPage/NotFoundPage";
import StatuteMain from "pages/StatutePage/StatuteMain";
import { useState } from "react";
import ActivitiesCalendar from "pages/MainPage/ActivitiesCalendar/ActivitiesCalendar";
import BenfitCardsSection from "pages/MainPage/BenfitCardsSection/BenfitCardsSection";
import GymCoaches from "pages/GymCoaches/GymCoaches";
import GalleryInviteSection from "pages/MainPage/GalleryInviteSection/GalleryInviteSection";
import CoachesAchievements from "pages/CoachesAchievementsPage/CoachesAchievements";
import PassesSectionV2 from "pages/MainPage/PassesSection/PassesSectionV2";

const App = () => {
  const [headerAnimated, setHeaderAnimated] = useState<boolean>(false);
  const headerWasAnimated = () => {
    setHeaderAnimated(true);
  };

  return (
    <div className="App">
      <div className="WebApp">
        <BrowserRouter>
          <ScrollTop>
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <Header
                      headerAnimated={headerAnimated}
                      headerWasAnimated={headerWasAnimated}
                    />
                    <MainScreen headerAnimated={headerAnimated} />
                    <GalleryInviteSection />
                    <PassesSectionV2 />
                    <BenfitCardsSection />
                    <GymCoaches />
                    <ActivitiesCalendar />
                    <LocalizationSection />
                    <GymEntranceInstruction />
                    <Footer />
                    <MobileMenu />
                  </>
                }
              />
              <Route
                path="/gallery"
                element={
                  <div>
                    <Header
                      headerAnimated={headerAnimated}
                      headerWasAnimated={headerWasAnimated}
                    />
                    <MainGallery />
                    <Footer />
                    <MobileMenu />
                  </div>
                }
              />
              <Route
                path="/statute"
                element={
                  <div>
                    <Header
                      headerAnimated={headerAnimated}
                      headerWasAnimated={headerWasAnimated}
                    />
                    <StatuteMain />
                    <Footer />
                    <MobileMenu />
                  </div>
                }
              />
              <Route path="*" element={<NotFoundPage />} />
              <Route
                path="/coaches-achievements"
                element={
                  <div>
                    <Header
                      headerAnimated={headerAnimated}
                      headerWasAnimated={headerWasAnimated}
                    />
                    <CoachesAchievements />
                    <Footer />
                    <MobileMenu />
                  </div>
                }
              />
            </Routes>
          </ScrollTop>
        </BrowserRouter>
      </div>
    </div>
  );
};

export default App;
